<div>
  <form [formGroup]="renamePasskeyUsernameForm" (ngSubmit)="onSubmit()" autocomplete="off">
    <h1 class="text-title-4 mb-8">
      Rename passkey
    </h1>
    <p class="text-body-lg mb-8">
      Enter a new name for this passkey
    </p>


    <div class="row">
      <div class="col-8 mt-16 mb-16">
        <ds-form-field>
          <ds-input-label>{{
            'rogers.changeUsername.changeUsernameForm.username' | translate
            }}
          </ds-input-label>
          <input
            dsInput
            type="email"
            [attr.autocorrect]="'off'"
            spellcheck="false"
            autocapitalize="off"
            formControlName="renamePasskeyUsername"
            (keydown.space)="$event.preventDefault()"
            (keydown.enter)="keyDownEnter($event)"
            [attr.aria-required]="true"
          [attr.aria-label]="
          'rogers.changeUsername.changeUsernameForm.attrUsername'| translate "
            [attr.title]="'rogers.changeUsername.changeUsernameForm.attrUsername'| translate "
            #renamePasskeyUsernameInput
            />
          </ds-form-field>
        </div>
      </div>
      <div class="mb-16">   
      </div>
      <div>
        <button
          type="submit"
          ds-button
          class="w-25 mb-16"
          title="{{ 'rogers.changeUsername.changeUsernameForm.continue' | translate }}"
          #continueBtn
          >

            <span>Save</span>
        </button>

        <button
          type="button"
          ds-button
          variant="secondary"
          class="ml-8 w-25 mb-16"
          title="{{ 'common.cancel' | translate }}"
          #continueBtn
          (click)="onPasskeyRenameCancel()">
            <span>{{ 'common.cancel' | translate }}</span>
        </button>
    </div>
  </form>
</div>
